<template>
  <div id="app">
   <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  img[lazy="loading"]{
    display:block;
    width:50px !important;
    height:50px !important;
    margin:60px auto;
  }
</style>
